/**
 * Links into the public API documentation on the marketing site.
 *
 * The documentation lives on `urlshot.io/docs/`, not in the dashboard, so every link is built from
 * `PUBLIC_SITE_URL` rather than written as a path. A relative `/docs/` would resolve against
 * `app.urlshot.io` and land on the dashboard's own not-found page.
 *
 * Sections are a closed list because each one is an `id` on the documentation page, owned by
 * another application. A renamed heading there would leave a link here that opens the page at the
 * top with no error anywhere; the test beside this file reads the page and fails instead.
 */
import { env } from '../env';

export const DOCS_SECTIONS = ['parameters', 'errors'] as const;

export type DocsSection = (typeof DOCS_SECTIONS)[number];

/**
 * The documentation page, optionally scrolled to one section.
 *
 * `/docs/` with its trailing slash, because `/docs` answers with a redirect: one extra round trip,
 * and a redirect that drops the fragment in some browsers would lose the section.
 */
export function docsUrl(section?: DocsSection, siteUrl: string = env.PUBLIC_SITE_URL): string {
  const url = new URL('/docs/', siteUrl);
  if (section !== undefined) url.hash = section;
  return url.href;
}
